import React from 'react';
import { Home, Gift, Users, User } from 'lucide-react';
import AppLogo from './AppLogo';

const Navigation = ({ currentView, onViewChange }) => (
  <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
    <div className="max-w-md mx-auto px-4">
      <div className="flex justify-around py-2">
        <button
          onClick={() => onViewChange('dashboard')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg ${
            currentView === 'dashboard' 
              ? 'text-green-600 bg-green-50' 
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          <Home className="h-6 w-6 mb-1" />
          <span className="text-xs">Home</span>
        </button>
        
        <button
          onClick={() => onViewChange('actions')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg ${
            currentView === 'actions' 
              ? 'text-green-600 bg-green-50' 
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          <AppLogo className="h-6 w-6 mb-1 object-contain" />
          <span className="text-xs">Actions</span>
        </button>
        
        <button
          onClick={() => onViewChange('rewards')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg ${
            currentView === 'rewards' 
              ? 'text-green-600 bg-green-50' 
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          <Gift className="h-6 w-6 mb-1" />
          <span className="text-xs">Rewards</span>
        </button>

        <button
          onClick={() => onViewChange('feed')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg ${
            currentView === 'feed' || currentView === 'feed-admin'
              ? 'text-green-600 bg-green-50'
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          <Users className="h-6 w-6 mb-1" />
          <span className="text-xs">Community</span>
        </button>
        
        <button
          onClick={() => onViewChange('profile')}
          className={`flex flex-col items-center py-2 px-4 rounded-lg ${
            currentView === 'profile' 
              ? 'text-green-600 bg-green-50' 
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          <User className="h-6 w-6 mb-1" />
          <span className="text-xs">Profile</span>
        </button>
      </div>
    </div>
  </div>
);

export default Navigation;